export default __webpack_public_path__ + "static/media/location-1.6e0e5a9d.png";